// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__oomFY","inner":"style_inner__r89G2","itemList":"style_itemList__UFqib","social-container":"style_social-container__biaM8","noItem":"style_noItem__-Y52M"};